import React from "react";
import {
    CityFilter,
    MultiSelectFilter,
    RadiusFilter,
    ResetFiltersButton,
    SingleSelectFilter,
} from "components/ListPage/filters";
import { useInlineProviderFilters } from "./useInlineProviderFilters";

const FiltersBar: React.FC = () => {
    const { labels, options, selected, state, handlers } = useInlineProviderFilters();
    const {
        category,
        subcategory,
        city,
        posted,
        radius,
        radiusAll,
        radiusValue,
        rating,
        selectedCount,
        reset,
    } = labels;
    const { categories, subcategories, cities, minRatingClear, minRatings, postedPeriodClear, postedPeriods } = options;
    const {
        categories: selectedCategories,
        subcategories: selectedSubcategories,
        postedPeriod,
        radius: selectedRadius,
        city: selectedCity,
        minRating,
    } = selected;
    const { canUseRadius, hasInlineProviderFilters } = state;
    const {
        handleCategoryChange,
        handleSubcategoryChange,
        handlePostedPeriodChange,
        handleRadiusChange,
        handleMinRatingChange,
        handleCityInputChange,
        handleCitySelect,
        handleReset,
    } = handlers;

    return (
        <div className="grid w-full grid-cols-1 gap-x-3 gap-y-3 sm:grid-cols-3 xl:grid-cols-6">
            <MultiSelectFilter
                label={category}
                options={categories}
                selectedCountLabel={selectedCount}
                selectedValues={selectedCategories}
                onChange={handleCategoryChange}
            />

            <MultiSelectFilter
                disabled={subcategories.length === 0}
                label={subcategory}
                options={subcategories}
                selectedCountLabel={selectedCount}
                selectedValues={selectedSubcategories}
                onChange={handleSubcategoryChange}
            />

            <SingleSelectFilter
                clearOption={postedPeriodClear}
                label={posted}
                selectedValue={postedPeriod}
                options={postedPeriods}
                onChange={handlePostedPeriodChange}
            />

            <CityFilter
                label={city}
                inputValue={selectedCity}
                options={cities}
                onInputChange={handleCityInputChange}
                onSelect={handleCitySelect}
            />

            <RadiusFilter
                disabled={!canUseRadius}
                label={radius}
                radiusAllLabel={radiusAll}
                radiusLabel={radiusValue}
                selectedValue={selectedRadius}
                onChange={handleRadiusChange}
            />

            <SingleSelectFilter
                clearOption={minRatingClear}
                label={rating}
                selectedValue={minRating}
                options={minRatings}
                onChange={handleMinRatingChange}
            />

            {hasInlineProviderFilters ? (
                <div className="col-span-full justify-self-end">
                    <ResetFiltersButton label={reset} onReset={handleReset} />
                </div>
            ) : null}
        </div>
    );
};

export default FiltersBar;
